import React from "react";
import { Field } from "formik";

import { FormSelect } from "../../../../../components/ui";
import * as constants from "../constants";
import { INewRithmicAccountFormData } from "../index";

interface IProps {
  values: INewRithmicAccountFormData["formValues"];
}

const OriginalAccountTypeSelect: React.FC<IProps> = ({ values }) => {
  const renderOriginalAccountTypeMenuItem = (
    values: INewRithmicAccountFormData["formValues"],
    data: { value: string }
  ) => {
    const isSelectedNAOption = data.value === constants.ORIGINAL_ACCOUNT_TYPE[0].value;
    if (isSelectedNAOption) {
      return values.account_type.includes("GAU") ? { disabled: false } : { disabled: true };
    } else {
      return values.account_type.includes("TCP") ? { disabled: false } : { disabled: true };
    }
  };

  return (
    <Field
      name="original_account_type"
      label="Original Account Type"
      placeholder="Original Account Type"
      component={FormSelect}
      options={constants.ORIGINAL_ACCOUNT_TYPE}
      renderMenuItem={(data: { value: string }) => renderOriginalAccountTypeMenuItem(values, data)}
    />
  );
};

export default OriginalAccountTypeSelect;
